// react and mui stuff
import { createContext, Dispatch, SetStateAction, useContext } from "react";

import IconButton from "@mui/joy/IconButton";
import Snackbar from "@mui/joy/Snackbar";
import Typography from "@mui/joy/Typography";

import CloseRounded  from "@mui/icons-material/CloseRounded";


type color = "primary" | "neutral" | "danger" | "success" | "warning"
export type toast = {
  text: string
  color?: color
}

type UserContextType = {
  toast: toast | undefined;
  setToast: Dispatch<SetStateAction<toast|undefined>>;
}

export const ToastContext = createContext<UserContextType>({
  toast: undefined,
  setToast: () => {}
})

export default function Toast () {
  const { toast, setToast } = useContext(ToastContext);

  function close() {
    setToast(undefined)
  }

  return (
    <Snackbar
      open={Boolean(toast)}
      color={toast?.color}
      variant="soft"
      onClose={close}
      endDecorator={<IconButton onClick={close}><CloseRounded/></IconButton>}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Typography level="body-lg"><b>{toast?.text}</b></Typography>
    </Snackbar>
  )
}